export default __webpack_public_path__ + "static/bncff-mobile-3-9feb7309b4c8a6b5d3517e9f515635ed.jpg";